<template>
  <van-overlay :lock-scroll="false" :show="showGrade">
    <div class="grade-content">
      <div class="top-content flex flex-m text-center">
        <div class="grade-cancel" @click="cancel">取消</div>
        <div class="grade-title">请选择年级</div>
        <div class="grade-confirm" @click="confirm">确定</div>
      </div>
      <div class="dash-line"/>
      <div class="grade-wrap">
        <div v-for="(item, index) in gradeList" :key="index" class="grade-item-content">
          <div class="grade-type">{{ item.gradeName }}</div>
          <div class="flex  flex-w grade-item-btn-content">
            <div v-for="(obj, idx) in item.rows" :key="obj.gradeName + idx" :class="obj.checked ? 'grade-item-btn-check' :'grade-item-btn'" @click="onHandleGrade(item,index,obj,idx)">{{ obj.gradeName }}</div>
          </div>
        </div>
      </div>
    </div>
  </van-overlay>

</template>
<script>
import { Overlay } from 'vant';
export default {
  components: {
    [Overlay.name]: Overlay
  },
  props: {
    showGrade: {
      type: Boolean,
      default: true
    },
    gradeList: {
      type: Array,
      default: () => [

      ]
    }
  },
  data() {
    return {
      // gradeList: [{
      //   type: '小学',
      //   gradeItemList: [
      //     {
      //       grade: '一年级',
      //       checked: false
      //     }, {
      //       grade: '二年级',
      //       checked: false
      //     }, {
      //       grade: '三年级',
      //       checked: false
      //     }, {
      //       grade: '四年级',
      //       checked: false
      //     }, {
      //       grade: '五年级',
      //       checked: false
      //     }, {
      //       grade: '六年级',
      //       checked: false
      //     }
      //   ]
      // }, {
      //   type: '初中',
      //   gradeItemList: [
      //     {
      //       grade: '初一',
      //       checked: false
      //     }, {
      //       grade: '初二',
      //       checked: false
      //     }, {
      //       grade: '初三',
      //       checked: false
      //     }
      //   ]
      // }, {
      //   type: '高中',
      //   gradeItemList: [
      //     {
      //       grade: '高一',
      //       checked: false
      //     }, {
      //       grade: '高二',
      //       checked: false
      //     }, {
      //       grade: '高三',
      //       checked: false
      //     }
      //   ]
      // }],
      choseGrade: ''
    };
  },
  computed: {

  },
  methods: {
    onHandleGrade(item, index, obj, idx) {
      console.log(this.gradeList);
      this.gradeList.forEach((element, i) => {
        element.rows.forEach((ele, j) => {
          if (index === i && idx === j) {
            ele.checked = true;
          } else {
            ele.checked = false;
          }
        });
        this.$set(this.gradeList, i, element);
      });
      this.choseGrade = obj;
      console.log('this.choseGrade', this.choseGrade);
    },
    confirm() {
      this.$emit('confirm', this.choseGrade);
    },
    cancel() {
      this.$emit('cancel', this.choseGrade);
    }
  }
};
</script>

<style scoped lang="scss">
.grade-content {
  position: absolute;
  width: 100%;
  height: 100%;
  bottom: 0;
  background: #fff;
  // border-radius: 24px 24px 0 0;
  border-radius: 0;

  .top-content {
    height: 120px;

    .grade-cancel {
      width: 136px;
      font-size: 28px;
      font-family: $font-Regular;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.45);
      line-height: 120px;
      text-align: center;
    }

    .grade-title {
      width: fit-content;
      font-size: 28px;
      font-family: $font-Regular;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.65);
      line-height: 40px;
      margin-right: auto;
      margin-left: auto;
    }

    .grade-confirm {
      width: 136px;
      font-size: 28px;
      font-family: $font-Regular;
      font-weight: 400;
      color: $blue;
      line-height: 120px;
      text-align: center;
    }
  }

  .dash-line {
    width: 100%;
    height: 2px;
    background: rgba(224, 224, 224, 0.5);
  }

  .grade-item-content {
    padding-top: 40px;
    padding-left: 25px;
    padding-right: 25px;

    .grade-type {
      width: fit-content;
      font-size: 28px;
      font-family: $font-Regular;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.45);
      line-height: 40px;
      margin-left: 35px;
    }

    .grade-item-btn-content {
      .grade-item-btn {
        width: 203px;
        height: 72px;
        background: #fff;
        border-radius: 10px;
        border: 2px solid #e0e0e0;
        box-sizing: border-box;
        font-size: 30px;
        font-family: $font-Regular;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
        line-height: 72px;
        text-align: center;
        margin-top: 30px;
        margin-left: 15px;
        margin-right: 15px;
      }

      .grade-item-btn-check {
        width: 203px;
        height: 72px;
        background: #fff;
        background: rgba(2, 142, 241, 0.1);
        border-radius: 10px;
        border: 2px solid $blue;
        box-sizing: border-box;
        font-size: 30px;
        font-family: $font-Regular;
        font-weight: 400;
        color: $blue;
        line-height: 72px;
        text-align: center;
        margin-top: 30px;
        margin-left: 15px;
        margin-right: 15px;
      }
    }
  }
  .grade-wrap {
    overflow-y: auto;
    padding-bottom: 20px;
    height: calc(100% - 140px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mine/selectGrade.vue